<script setup lang="ts">
import {
  getCurrentInstance,
  nextTick,
  onActivated, onBeforeMount,
  onBeforeUnmount,
  onBeforeUpdate,
  onMounted,
  reactive,
  ref,
  watch
} from 'vue'
import { HTTP } from '@/network/http'
import { Close } from '@element-plus/icons-vue'
import { networkTip, resourceTypeText } from '@/stores/StaticText'
import {
  type cardType,
  messageEnum,
  type messageType
} from '@/stores/TypeIntertface'
import { Data } from '@/stores/data'
import { ElementTip } from '@/stores/ElementTip'
import { Utill } from '@/stores/Utill'
import axios from 'axios'
import SendItem from '@/components/Application/XhComponents/SendItem.vue'
import SendItemWd from '@/components/Application/XhComponents/SendItemWd.vue'
import MessageItem from '@/components/Application/XhComponents/MessageItem.vue'
import ModeContentItem from '@/components/Application/XhComponents/item/ModeContentItem.vue'
import Card from '@/components/Application/XhComponents/Card.vue'
import EnterView from '@/components/Application/XhComponents/EnterView.vue'
import LoadingItem from '@/components/Application/XhComponents/LoadingItem.vue'
import emitter from '../../stores/mitt'
import VideoMessageItem from '@/components/Application/XhComponents/item/VideoMessageItem.vue'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import SelectTextCard from '@/components/Application/XhComponents/item/SelectTextCard.vue'
import DownControl from './XhComponents/DownControl.vue'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import DocumentsItem from './XhComponents/item/DocumentsItem.vue'
import ZwHistory from '@/components/Application/XhComponents/ZwHistory.vue'
let cancel: any = null
let cancelToken = axios.CancelToken
const props = withDefaults(defineProps<{
  isHaveTitle?: boolean
  ishaveInitDate?: boolean
  isNewConversation?: boolean
  currentHistoryItem?: object
  isApplicationLink?: boolean

}>(), {
  isHaveTitle: true,
  ishaveInitDate: true,
  isNewConversation: true,
  currentHistoryItem: null,
  isApplicationLink: false,

})
const teachingPlainName = Data.basicSettingData.value?.content
const route = useRoute()
//小鸿聊问答页面进来resourceType为空，其他的页面都有对应的值
const resourceType = (route.params.resourceType ? route.params.resourceType : '') as string
// const emit = defineEmits();
const $emit = defineEmits(['closeXhDialogue', 'haveInformation', 'refreshHistoryList', 'postQuestion'])
let initTextList = {
  type: 'gradeChange',
  content: {
    text: '关于《' + teachingPlainName + '》这一课有任何问题我都可帮您解答',
    tip: '*在文档中选中文字可精准提问'
  }
}

let workInitTextList = {
  type: 'gradeChange',
  content: {
    text:
      '老师好！我是您的助教——小鸿！我能辅助您完成' +
      resourceTypeText[resourceType] +
      '的编写，快向我下发指令吧！',
    tip: ''
  }
}

let initCardList = ref<any[]>([])

const xiaoxiArr = ref<messageType[]>([]) //消息

const hosXiaoxiArr = ref<any>([]) //历史消息

let lodingShow = ref(false) //loding是否显示

//发送消息的来源，0 代表输入文字发送，1 代表点击卡片发送
let sendFrom = ref(-1) //卡片发送的不出现终止按钮
let isSending = ref(false) //消息是否正在接收中
// let pdfShowSrc = ref('')
let controller
let signal
let currentType
//下拉刷新
var scFra: HTMLElement | null = null //滚动区域
var _refreshText: HTMLElement | null = null //下拉提醒文字dom
let lastScrollHeight = 0
let isGetHosData: boolean = false //是否已经获取过历史记录了
var es: EventSource
let timer: any //文字显示计时器
let _streamId: string = '' //stream信息容器dom的id
let alltext = '' //接收到的文字
let strforcode = '_' //显示的文字
let str_ = '' //比显示文字少了_
let isalltext = false //文字是否全部接收完

const instance = getCurrentInstance()?.proxy //公开的变量，引入公式用的

let isClickAnliItem = ref(false) //是否点击了教案的案例

let isStartSteam = ref(false) //是否开始 stream

let FAQList = ref<any[]>([])

const timestamp = ref<string>('');
const newTimestamp = ref<string>('');

const fixedTimestamp = ref<string>('');

const offset = ref(0);
const imgOrVideoProblem = ref('');

emitter.on('xhFAQ-Dialogue', xhFAQDialogue)
emitter.on('appLink-QA', appLinkQA)
onBeforeUnmount(() => {
  emitter.off('xhFAQ-Dialogue', xhFAQDialogue)
  emitter.off('appLink-QA', appLinkQA)
})
let aQSelectedText = ref('');
function xhFAQDialogue(selectedText: string) {
  console.log('>>xhFAQDialogue>>>>', selectedText)
  getCardData(2, selectedText)
  aQSelectedText.value = selectedText;
  console.log('>>FAQList>>>>', FAQList.value)

  // addMassage(FAQList, 3, false, false, false, false, true, selectedText)
}

onBeforeMount(() => {
  fixedTimestamp.value = String(Date.now())
  offset.value = 0
  imgOrVideoProblem.value = ''
  console.log('>>fixedTimestamp.value111>>>>', fixedTimestamp.value)
})
onBeforeUnmount(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload)
})
window.addEventListener('beforeunload', handleBeforeUnload)

function handleBeforeUnload() {
  fixedTimestamp.value = String(Date.now())
  offset.value = 0
  imgOrVideoProblem.value = ''
  console.log('>>fixedTimestamp.value222>>>>', fixedTimestamp.value)
}

function appLinkQA(sendText: string) {
  console.log('>>appLink-QA>>>>', sendText)
  if (sendText) {
    sendQuestion(sendText)
  }
  console.log(xiaoxiArr.value)
}
init()
//初始化卡片内容
function init() {
  closeStream(null);
  aQSelectedText.value = '';
  Data.setCurrMode('noMode')
  Data.uploadDocumentsData.documentsData = [];
  Data.uploadDocumentsData.wjGroup = '';
  console.log(">resourceType>>>>>", resourceType)
  if (resourceType) {
    if (resourceType == 'lesson' || resourceType == 'courseware') {
      addMassage(initTextList)
      getCardData(1, teachingPlainName)
      console.log('猜你想问：', initCardList.value)
    }
    else {
      addMassage(workInitTextList)
    }
  }

}
// watch([xiaoxiArr.value, hosXiaoxiArr.value], ([newXiaoxiArr, newHosXiaoxiArr]) => {
//   console.log(newXiaoxiArr,'有新消息或历史消息更222新',newHosXiaoxiArr);
//       if (newXiaoxiArr.length > 0 || newHosXiaoxiArr.length > 0) {
//         // 触发更新事件
//         $emit('haveInformation',false);

//         console.log('有新消息或历史消息更新');
//         // 在这里添加你想要执行的逻辑
//       }
//     });
watch(
  () => props.isNewConversation,
  (newValue, oldValue) => {
    console.log(props.isNewConversation)
    if (props.isNewConversation) {
      refreshAllMessage()
    }
  }
)

watch(
  () => props.currentHistoryItem,
  (newValue, oldValue) => {
    console.log(props.currentHistoryItem)
    if (props.currentHistoryItem) {
      xiaoxiArr.value = []
      hosXiaoxiArr.value = []
      timestamp.value = ''
      newTimestamp.value = ''
      init();
      $emit('haveInformation', false);
      console.log(props.currentHistoryItem)
      hosXiaoxiArr.value = (props.currentHistoryItem as any).content
      setScrollTop()
      console.log(hosXiaoxiArr.value)
    } else {
      refreshAllMessage()
      hosXiaoxiArr.value = []
    }
  }
)

watch(
  () => isStartSteam.value,
  (newValue, oldValue) => {
    console.log(isStartSteam.value)
    emitter.emit('isStartSteam', isStartSteam.value)
  }
)

//添加消息数据
function addMassage(
  text: any | string | Array<cardType> = networkTip.errText,
  type: messageEnum = 1,
  isCopy: boolean = false,
  isHtml: boolean = false,
  isImg: boolean = false,
  isFeedback: boolean = false,
  isFAQ: boolean = false,
  selectText: string = '',
  id: string = '',
  isShowJiaoanBtn: boolean = false,
  loadingType: number[] = [3],
  otherData: any = {}
) {
  $emit('haveInformation', false);
  lodingShow.value = false
  //2和 9 为发送的数据
  if (type != 2 && type != 9) {
    isSending.value = false
    isStartSteam.value = false
    clickAnliFalse()
  }

  if (id == '' && !xiaoxiArr.value.some((item) => item.id == id)) {
    console.log('>>>>>>lhg000', text)
    let _id = 'mess-' + type + '-' + xiaoxiArr.value.length
    let errorText: messageType = {
      text,
      type,
      isCopy,
      isHtml,
      isImg,
      isFeedback,
      isFAQ,
      selectText,
      id: _id,
      isShowJiaoanBtn,
      loadingType,
      otherData
    }
    xiaoxiArr.value.push(errorText)
    console.log('>>>>>>lhg001', xiaoxiArr.value)
    if (type != 6) {
      mathJaxShow(_id)
    }
  } else {
    console.log('>>>>>>lhg111')
    addPush(id, text)
  }
  setScrollTop()
}

function clickAnliFalse() {
  Data.currClickAnliItemData.value = null
  if (isClickAnliItem.value) {
    //如果已经是false，就不再修改
    isClickAnliItem.value = false
    // Utill.submitTeaching({}, 'jiaoan', 2);//让服务器退出案例模式，前端没有进入模式，所以不需要同步推出
  }
}

function mathJaxShow(idStr, isClear: boolean = false) {
  // todo 现在用了markdown插件，自带的公式渲染，这里就暂时注释的了，等两期没什么问题，可以删除
  //如果打开，messageItem里面v-for有问题需要单独处理一下
  nextTick(() => {
    console.log('>>>>aaaa>>>>', idStr)
    try {
      if (document.getElementById(idStr)) {
        //@ts-ignore
        instance?.$renderMath(document.getElementById(idStr))
      }
    } catch (error) { }
  })
}

function addPush(id: string, str: string = networkTip.errText) {
  let item = xiaoxiArr.value.find((item) => item.id == id)
  if (!item) {
    return
  }
  if (typeof item!.text === 'string') {
    let arr = []
    arr.push(item!.text)
    arr.push(str)
    item!.text = arr
    let arrIsCopy = []
    arrIsCopy.push(item!.isCopy as boolean)
    arrIsCopy.push(false)
    item!.isCopy = arrIsCopy
    // item.loadingType.push(1);
  } else {
    if (str == '_') {
      //新增
      console.log('>>>>>>lhg13333')
        ; (item!.text as Array<string>).push(str)
        ; (item!.isCopy as Array<Object>).push(false)
      //  item.loadingType.push(1);
    } else {
      //修改（请求错误的时候会走这里）
      console.log('>>>>>>lhg222')
        ; (item!.text as Array<string>)[item!.text.length - 1] = str
        ; (item!.isCopy as Array<Object>)[item!.text.length - 1] = true
      // (item!.isCopy as Array<Object>).push(true);
      item.loadingType[item.text.length - 1] = 3
    }
  }

  console.log('item.text>>>', item!.text)
}

function setScrollTop() {
  console.log(">setScrollTop>>>>")
  nextTick(() => {
    if (scFra != null) {
      scFra.scrollTop = 100000
      console.log(">setScrollTop>>22>>", scFra.scrollTop)
      // scrollbarRef.value!.setScrollTop(100000)
    }
  })
}

function upLoadClick(url: string) {
  // pdfShowSrc.value = 'https://du.ikeben.cn/t/7a498efcd681780dbb11c41bea432b94.jpg';
  console.log(Data.pdfShowSrc.value, 'pdfUrl>>>>>', url)
  Data.pdfShowSrc.value = url
}
function getUploadData(wjId: string) {
  let wjData = ref({
    data: {
      name: '',
      size: '',
      fileType: '',
      pdfUrl: '',
    },
    errorTip: '上传失败',
    loadingState: 1,
    wjId: wjId,
    text: '整理文档的核心内容',
  })
  Data.uploadDocumentsData.documentsData.push(wjData)

  HTTP.getUploadData(wjId, {
    cancelToken: new cancelToken((c) => (cancel = c)),
  })
    .then((res: any) => {
      let _data = res.data
      if (_data) {
        if (_data.status && _data.status == 2) {//这个是用户取消上传（微信没有选择文件状态）
          //取消上传
          console.log('取消上传>')
          Data.uploadDocumentsData.documentsData = Data.uploadDocumentsData.documentsData.filter(item => item.value.wjId !== _data.wjId);
          return
        }
        if (_data.name) {
          wjData.value.data.name = _data.name
        }
        if (_data.size) {
          wjData.value.data.size = _data.size
        }
        if (_data.fileType) {
          wjData.value.data.fileType = _data.fileType
        }
        if (_data.pdfUrl) {
          wjData.value.data.pdfUrl = _data.pdfUrl
        }
      }
      if (res.code == 200) {
        wjData.value.errorTip = ''
        wjData.value.loadingState = 2 //成功
        // lodingShow.value = true
        // setScrollTop()
        console.log('>>lodingShow.value>>>', lodingShow.value)
        // newCoursewareDetail(wjData.value.text, '', { upDataId: { wjId } })
      } else {
        wjData.value.loadingState = 3 //失败
        if (res.descb) {
          wjData.value.errorTip = res.descb
        }
        // isSending.value = false
      }
      console.log('res>>>', res)
    })
    .catch((err) => {
      isSending.value = false
      if (axios.isCancel(err)) {//取消上传请求（正在上传中取消了）
        console.log('err>>取消>', err)
        // wjData.value.data.name = '已取消'
      }
      if (err.descb) {
        wjData.value.errorTip = err.descb
      }
      console.log('err>222>>', err)
      wjData.value.loadingState = 3 //失败
    })
}
function qxHandler(wjId: any) {
  // if(cancel){
  //   cancel('取消请求')
  // }
  Data.uploadDocumentsData.documentsData = Data.uploadDocumentsData.documentsData.filter(item => item.value.wjId !== wjId);
  console.log("取消请求>>>>", Data.uploadDocumentsData.documentsData)

}
//获取回答的问题
function getAnswerProblem(index: number) {
  let arr = xiaoxiArr.value
  for (let i = index; i >= 0; i--) {
    if (arr[i].type == 2 || arr[i].type == 9) {
      console.log(' arr[i].text>>>>', arr[i].text)
      return arr[i].text
    }
  }
  return ''
}

//显示点踩反馈面板，调整滚动条
function showFeedback(item: HTMLElement | null) {
  if (item && scFra) {
    nextTick(() => {
      const pullToRefreshRect = scFra!.getBoundingClientRect()
      const itemRect = item.getBoundingClientRect()
      // 检查item4的底部是否在视口内
      const isItem4BottomInViewport = itemRect.bottom <= pullToRefreshRect.bottom
      console.log(
        itemRect.bottom,
        'isItem4BottomInViewport>>>',
        isItem4BottomInViewport,
        '>>',
        pullToRefreshRect.bottom
      )
      // 如果item4的底部不在视口内，则将滚动条滚动到item4的底部，使item4显示在视口内
      if (!isItem4BottomInViewport) {
        const scrollTop = itemRect.bottom - pullToRefreshRect.bottom + scFra!.scrollTop
        scFra!.scrollTop = scrollTop
      }
    })
  }
}
async function videoanginAnswer({ id, problem }: { id: string; problem: string | any }) {
  if (isSending.value) {
    ElementTip.warningTip('请耐心等待小鸿把话说完')
    return
  }
  if (problem && id) {
    if (imgOrVideoProblem.value && imgOrVideoProblem.value == problem) {
      offset.value = offset.value + 1
    } else {
      imgOrVideoProblem.value = problem
      offset.value = 1
    }
    let item = xiaoxiArr.value.find((item) => item.id == id)
    if (item) {
      xiaoxiArr.value = xiaoxiArr.value.filter((item) => item.id !== id)
      getDate(problem, id, {}, true, 1, offset.value)
    }
  }
}

//点击重新回答逻辑
async function anginAnswer({ id, problem }: { id: string; problem: string | any }) {
  if (isSending.value) {
    ElementTip.warningTip('请耐心等待小鸿把话说完')
    return
  }
  console.log('id, problem>>>', id, '>>>', problem)
  if (problem && id) {
    let item = xiaoxiArr.value.find((item) => item.id == id)
    if (item) {
      addPush(id, '_')
      // if (problem.batchList) {
      //   //批量生产
      //   getDate(problem, id, { batchList: problem.batchList }, false, 2)
      // } 
      if (problem.upDataId) {
        getDate(problem, id, { upDataId: problem.upDataId }, false, 2)
      } else {
        getDate(problem, id, {}, false, 2)
      }
    }
  }
}

//获取消息请求
async function getDate(
  text: string | any,
  id: string = '',
  embedInformation: any = {},
  haveIdIsShowLoading: boolean = false,
  replace: number = 0,
  offset: number = 0,
) {
  if (Utill.showLoginDialog()) {
    return
  }
  await Utill.checkRemaining()
  if (Data.userInfo.value?.lv == 0) {
    //新用户
    console.log('新用户总剩余次数', Data.lastCanCountByUser.value)
    if (Data.lastCanCountByUser.value == 0) {
      ElMessage({
        message: '您的使用次数已全部用完',
        type: 'warning',
        plain: true
      })
      Utill.showMemberOrActivityDialog()
      return
    }

  } else {
    //非新用户
    console.log('今日剩余次数', Data.userInfo.value?.remaining)
    if (Data.userInfo.value?.remaining == 0) {
      ElMessage({
        message: '今日您的使用次数已用完',
        type: 'warning',
        plain: true
      })
      return
    }
  }
  console.log('>>>>>33333>>>>', text)
  let _text = ''
  if (typeof text === 'string') {
    _text = text
  } else {
    _text = text.text
  }
  //添加用户发送的消息
  isSending.value = true
  if (id == '') {
    if (embedInformation?.upDataId && embedInformation?.upDataId?.data) {
      console.log('>>>', embedInformation?.upDataId)
      Data.setCurrMode('wdwd')
      addMassage({ text, upDataId: embedInformation?.upDataId }, 9)
    } else {
      console.log('>text>>222', text)
      addMassage(text, 2)
    }

    // sendText.value = ''
    _text = _text.trim() //去掉首尾空格
    if (_text == '') {
      console.log('>>请输入需要问的问题>>')
      addMassage(networkTip.nullText)
      return
    }
    lodingShow.value = true
  }
  if (haveIdIsShowLoading) {
    lodingShow.value = true
  }

  // newCoursewareDetail(_text, id, embedInformation)
  newStreaming(_text, id, embedInformation, replace, offset)
}


/**
 *
 * @param text
 * @param id
 * @param embedInformation
 * @param replace 0正常问答  1图视频换一换  2重新回答
 */
async function newStreaming(
  text: string | any,
  id: string = '',
  embedInformation: any = {},
  replace: number = 0,
  offset: number = 0

) {

  // await Utill.checkRemaining()
  // if (Data.userInfo.value?.lv == 0) {
  //   //新用户
  //   console.log('新用户总剩余次数', Data.lastCanCountByUser.value)
  //   if (Data.lastCanCountByUser.value == 0) {
  //     ElMessage({
  //       message: '您的使用次数已全部用完',
  //       type: 'warning',
  //       plain: true
  //     })
  //     let dialogData = {
  //       show: true,
  //       activityDialogType: '',
  //       activityDialogTitle: "邀请活动"
  //     }
  //     console.log(dialogData)
  //     emitter.emit('show-actDialog', dialogData)
  //     return
  //   }

  // } else {
  //   //非新用户
  //   console.log('今日剩余次数', Data.userInfo.value?.remaining)
  //   if (Data.userInfo.value?.remaining == 0) {
  //     ElMessage({
  //       message: '今日您的使用次数已用完',
  //       type: 'warning',
  //       plain: true
  //     })
  //     return
  //   }
  // }

  //新接口不需要
  // if (!props.isHaveTitle) {
  //   //小鸿问答
  //   currentType = 'chat'
  // }else {
  //   //其他类型
  //   currentType = resourceType
  // }



  // if (props.isNewConversation) {
  //   //新对话
  //   timestamp.value = String(Date.now());
  //   newTimestamp.value = timestamp.value;
  // }

  // if (props.currentHistoryItem) {
  //   //历史记录继续提问
  //   timestamp.value = (props.currentHistoryItem as any).timeStamp
  //   newTimestamp.value = String(Date.now());
  // } else {
  //   //新对话
  //   if (timestamp.value) {
  //     //新创建对话 已经有问答记录（最新一条记录，已经加入历史记录）
  //     timestamp.value = newTimestamp.value;
  //     newTimestamp.value = String(Date.now())
  //   } else {
  //     //新创建对话 没有任何问答记录（还未加入历史记录）
  //     timestamp.value = String(Date.now());
  //     newTimestamp.value = timestamp.value;
  //   }
  // }

  if (newTimestamp.value) {
    timestamp.value = newTimestamp.value;
    newTimestamp.value = String(Date.now());
  } else {
    if (props.isNewConversation) {
      //新对话
      timestamp.value = String(Date.now());
      newTimestamp.value = timestamp.value;
    }
    if (props.currentHistoryItem) {
      //历史记录继续提问
      timestamp.value = (props.currentHistoryItem as any).timeStamp
      newTimestamp.value = String(Date.now());
    }
  }
  console.log(sendFrom.value, '>>>>>>sendFrom.value', isSending.value)
  //如果已经发送过内容，并且正在回答中

  if (sendFrom.value == 0 && !isSending.value && id == '') {
    lodingShow.value = false
    return
  }
  controller = new AbortController()
  signal = controller.signal

  console.log('>>>>>>EventSource')
  alltext = '' //接收到的文字
  strforcode = '_' //显示的文字
  str_ = '' //比显示文字少了_
  isalltext = false //是否全部接收完毕
  let isstarted = true //第一次成功返回
  let backText: messageType

  let isSwitch = id != '' && xiaoxiArr.value.find((item) => item.id == id)
  if (isSwitch) {
    _streamId = id
    backText = xiaoxiArr.value.find((item) => item.id == id)!
    backText.loadingType.push(1)
  } else {
    _streamId = 'mess-0-' + xiaoxiArr.value.length
    backText = reactive({
      text: ['_'],
      type: 0,
      isCopy: [false],
      isHtml: !!resourceType,
      isImg: false,
      isFeedback: true,
      isFAQ: false,
      selectText: embedInformation.selectText ? embedInformation.selectText : '',
      id: _streamId,
      isShowJiaoanBtn: false,
      loadingType: [1],
      otherData: { currMode: Data.currMode.value }
    })
  }
  console.log(xiaoxiArr.value, ">>>>>embedInformation.selectText >>>>", embedInformation.selectText)
  // console.log('!!!!selectText', xiaoxiArr.value[xiaoxiArr.value.length - 2].selectText)
  // let selectContent = ''
  // if (xiaoxiArr.value.length > 1 && xiaoxiArr.value[xiaoxiArr.value.length - 2].selectText != '') {
  //   selectContent = xiaoxiArr.value[xiaoxiArr.value.length - 2].selectText
  //   // xiaoxiArr.value.filter(item => item.selectText == '');
  // }
  // else {
  //   selectContent = text
  // }

  // if(text.includes('视频')){
  //   backText.type = 11
  // }
  isStartSteam.value = true
  try {
    let gptQuestion: any = {
      embedInformation,
      content: text,
      type: 1,
      original: backText.selectText ? backText.selectText : '',
      replace: replace,
      sessionId: Data.sessionId.value,
      resourceType: currentType,
      timeStamp: timestamp.value,
      thinking: false,
      newTimeStamp: newTimestamp.value,
      offset: offset,
    }
    let url = '/ai/question';
    if (!resourceType) {
      url = '/ai/deepseek/qa'
      // url = '/newapipc/emb/newapipc.php'
      gptQuestion = { ...gptQuestion, xhOnline: Data.currMode.value == 'lwss' ? 1 : 2 }
      // HTTP.cscs(gptQuestion);
      // return;
    }

    fetchEventSource(Utill.getBaseURL() + 'api/pc' + url, {
      method: 'POST',
      // 请求头参数
      headers: {
        token: Data.token.value,
        'Content-Type': "application/json"
      },
      // 具体传参
      body: JSON.stringify(gptQuestion),
      openWhenHidden: true, // 在调用失败时禁止重复调用
      signal: signal,

      onmessage(event: any) {
        // const res: any = JSON.parse(msg.data);
        console.log('message', event.data)

        if (isstarted && alltext.length > 0) {
          isstarted = false
          if (!isSwitch) {
            xiaoxiArr.value.push(backText)
            backText.type = 0
            // getSimilarData(backText)
          }

          // if(text.includes('视频')){
          //   backText.type = 11
          // }
          lodingShow.value = false
          // isStartSteam.value = true

          if (timer) {
            clearInterval(timer)
          }

          timer = setInterval(() => {
            console.log('>>>>>>>>>22222>>>>>>')
            let newalltext = alltext
            if (newalltext.split('\n\n').length == newalltext.split('\n').length) {
              newalltext = newalltext.replace(/\\n\\n/g, '\n')
            }

            if (str_.length < newalltext.length) {
              str_ += newalltext[str_.length]
              strforcode = str_ + '_'
              // console.log(">>>>",str_)
              if (str_.split('```').length % 2 == 0) strforcode += '\n```\n'
            } else {
              if (isalltext) {
                console.log('>>>lhg346>stream返回完成>>', alltext)
                clearInterval(timer)
                strforcode = str_
                  ; (backText.isCopy as Array<boolean>)[backText.text.length - 1] = true
                backText.loadingType[backText.text.length - 1] = 2
                isSending.value = false
                isStartSteam.value = false
                if (isClickAnliItem.value) {
                  backText.isShowJiaoanBtn = true
                  clickAnliFalse()
                }
              }
            }
            ; (backText.text as Array<string>)[backText.text.length - 1] = strforcode
            mathJaxShow(_streamId, true)
            setScrollTop()
          }, 30)
        }

        if (event.data == '[DONE]') {
          console.log('[DONE]>>stop>')
          isalltext = true

          controller.abort()
          Utill.checkRemaining()
          $emit('refreshHistoryList');
          return
        }
        if (event.data == 'data: [DONE]') {
          console.log('[DONE]dd>>stop>')
          isalltext = true
          // ctrl.signal[0].aborted = false;
          controller.abort()
          Utill.checkRemaining()
          $emit('refreshHistoryList');
          return
        }
        var json = JSON.parse(event.data)
        // console.log('event.data>>>>',event.data)
        if (json.choices && json.choices[0] && json.choices[0].hasOwnProperty('finish_reason')) {
          if (json.choices[0].finish_reason == 'stop') {
            isalltext = true
            // loadingType.value = 3
            // backText!.isCopy = true
            console.log('finish_reason>>stop>')
            controller.abort()
            return
          }
        }
        // console.log(json.choices[0], json.choices[0].delta.hasOwnProperty('content'),'>>>4443333>>', alltext)
        if (
          json.choices &&
          json.choices[0] &&
          json.choices[0].delta &&
          json.choices[0].delta.hasOwnProperty('content')
        ) {
          let text = json.choices[0].delta.content
          if (alltext == '') {
            alltext = text.replace(/^\n+/, '') //去掉回复消息中偶尔开头就存在的连续换行符
          } else {
            alltext = alltext + text
          }

          // if(backText.type == 11){
          //   if(alltext.includes('[观看视频]')){
          //     let backTextList:string[] =alltext.split('\n\n')
          //     backText.text = parseStringsToArray(backTextList)
          //     console.log(backText.text)

          //   }
          // }
          console.log('>>>>cdcdcd>>>>>', alltext)
        } else if (json.choices &&
          json.choices[0] &&
          json.choices[0].message) {

          if (json.choices[0].message.hasOwnProperty('content')) {
            let text = json.choices[0].message.content
            if (alltext == '') {
              alltext = text.replace(/^\n+/, '') //去掉回复消息中偶尔开头就存在的连续换行符
            } else {
              alltext = alltext + text
            }

          }
          console.log('>>>>cdcdcd>>呃呃呃>>>', alltext)

        } else {
          if (json.tuWenAndVideo) {
            xiaoxiArr.value.push(backText)
            clearInterval(timer)
            lodingShow.value = false
            isSending.value = false
            isStartSteam.value = false
            backText.type = 11
            backText.otherData = json.tuWenAndVideo
            backText.loadingType[backText.text.length - 1] = 2
            setScrollTop()
          }
        }
        // showLoading.value = false;
      },
      onclose() {

        console.log('close》〉')
        controller.abort()
      },
      onerror(err) {
        console.log('>>onerror>>小鸿忙，请稍后重试>>>>')
        // closeStream('小鸿忙，请稍后重试', 1)
        addMassage(networkTip.errText, 1, false, false, false, false, false, '', _streamId)
        controller.abort()
        throw err

        if (!xiaoxiArr.value.find((item) => item.id == backText.id)) {
          addMassage(networkTip.errText, 1, false, false, false, false, false, '', _streamId)
          //如果已经有返回的内容，再报错也不再显示错误对话
          // addMassage()
        }
        return
      }
    })
  } catch (err) {
    console.log('>>onerror>>小鸿忙，请稍后重试>>>22>')
    if (!isstarted) {
      addMassage(networkTip.errText, 1, false, false, false, false, false, '', _streamId)
    }
    console.log(err)
    if (err.code === 1007) {
      console.log('剩余次数已用完')
      ElMessage({
        message: '您的使用次数已全部用完',
        type: 'warning',
        plain: true
      })
      Utill.showMemberOrActivityDialog()
    }
  }
}

//获取卡片数据
function getCardData(type: number, title: string) {
  const cardInfo = {
    type: type,
    title: title,
    sessionId: Data.sessionId.value
  }
  HTTP.getCardData(cardInfo as any)
    .then(
      (res) => {
        console.log(res)
        if (type == 1) {
          const initList = []
          for (let i = 0; i < res.data.caseVOS.length; i++) {
            console.log(res.data.caseVOS[i])
            let initItem = {
              title: res.data.caseVOS[i].name,
              content: res.data.caseVOS[i].name
            }
            initList.push(initItem)
          }
          initCardList.value = initList
          if (initCardList.value.length > 0) {
            addMassage(initCardList.value, 3, false, false, false)
          }
        } else if (type == 2) {
          const caseList = []
          for (let i = 0; i < res.data.caseVOS.length; i++) {
            console.log(res.data.caseVOS[i].name.startsWith('---'))
            if (res.data.caseVOS[i].name.startsWith('---')) {
              res.data.caseVOS[i].name = res.data.caseVOS[i].name.replace(/^[-\n]+/, '')
            }
            console.log(res.data.caseVOS[i].name)
            let caseItem = {
              title: res.data.caseVOS[i].name,
              content: res.data.caseVOS[i].name
            }
            caseList.push(caseItem)
          }
          FAQList.value = caseList
          console.log(FAQList.value)
        }
      },
      (err) => { }
    )
    .catch((e) => { })
}

function closeStream(back: messageType | undefined, frome: number = 0) {
  if (timer) {
    clearInterval(timer)
  }
  if (controller) {
    controller.abort()
  }
  if (back) {
    console.log('back>>>', back)
    let _text = (back.text as Array<string>)[back.text.length - 1]
    if (back && back.type == 0) {
      if ((_text as string).endsWith('_')) {
        ; (back.text as Array<string>)[back.text.length - 1] = _text.slice(0, -1)
        if ((back.text as Array<string>)[back.text.length - 1] == '') {
          if (frome == 1) {
            ; (back.text as Array<string>)[back.text.length - 1] = networkTip.errText
          } else {
            ; (back.text as Array<string>)[back.text.length - 1] = '已停止回答'
          }
        }
        console.log('backlhg>>>', back)
      }
      //这个从(_text as string).endsWith('_')里面移出来，是因为如果是代码的时候最后三个会是```导致结束的时候
      if (_text != '_' || back.text.length > 1) {
        ; (back.isCopy as Array<boolean>)[back.text.length - 1] = true
        if (isClickAnliItem.value) {
          back.isShowJiaoanBtn = true
        }
        mathJaxShow(_streamId, true)
      }
      back.loadingType[back.text.length - 1] = 3
    }
  }
  clickAnliFalse()
  _streamId = ''
  if (es) {
    es.close()
  }
  lodingShow.value = false
  isSending.value = false
  isStartSteam.value = false
}

function addActionCard(card: string) {
  clickCard(card)
}

function clickCard(text: string, embedInformation: any = {}) {
  if (isSending.value) {
    ElementTip.warningTip('请耐心等待小鸿把话说完')
    return
  }
  aQSelectedText.value = '';
  // console.log(">>>>>>作文批改")
  // addMassage(csWZ(), 7)
  console.log(embedInformation, '>clickCard>>text>>', text)
  sendFrom.value = 1
  //   isSending.value = true
  getDate(text, "", embedInformation)
}

/**
 * isClickAnLi  是否是点击模板案例
 */
async function clickExampleCard(itemData: any, isClickAnLi: boolean = false) {
  if (isSending.value) {
    ElementTip.warningTip('请耐心等待小鸿把话说完')
    return
  }
  Data.currClickAnliItemData.value = itemData
  console.log('>>>>点击了案例>>', itemData)
  if (itemData.wjId) {
    //文档上传的案例
    console.log('>>>>2401点击了文档问答的案例>>')
    itemData.loadingState = 2
    //{
    // upDataId: {
    //     wjGroup: Data.uploadDocumentsData.wjGroup,
    //     data: arr,
    //   },
    // }
    // let _dataArr=[];
    sendQuestion(itemData.text, {
      upDataId: { wjGroup: itemData.wjId, data: [itemData], isCase: '2' }
    })
  } else if (itemData.data) {
    console.log('>>>>2401点击了带数据的案例>>', isClickAnLi)
    isClickAnliItem.value = isClickAnLi
    sendQuestion(itemData.text, itemData.data)
  } else {
    sendQuestion(itemData.text)
  }
}
// function sendQuestionHandler(text: string) {

// }

//向gpt发送文字
function sendQuestion(text: string, embedInformation: any = {}) {

  if (isSending.value) {
    ElementTip.warningTip('请耐心等待小鸿把话说完')
    return
  }
  aQSelectedText.value = '';
  sendFrom.value = 0
  // isSending.value = true
  getDate(text, '', embedInformation)
}

onMounted(() => {
  console.log('>>>>>>>>>>ghuazaila哈哈哈哈哈啊哈哈哈哈', document.body)

  if (document.getElementById('massage-ctr')) {
    scFra = document.getElementById('massage-ctr')
    _refreshText = document.getElementById('refreshText')
    // scFra?.addEventListener('touchstart', touchstartHander)

    // scFra?.addEventListener('click', clickHander);
  }
  document.addEventListener('visibilitychange', handleVisibilityChange, false)

  // bus.on("currModeChange",  () => {
  //     currModeChange();
  // });
})
onBeforeUpdate(() => {
  console.log('>>组件更新之前执行的函数；；>')
}),
  onBeforeUnmount(() => {
    console.log('>>组件卸载之前执行的函数；>')
    document.removeEventListener('visibilitychange', handleVisibilityChange, false)
  })

function stopMassage() {
  let res = undefined
  if (_streamId) {
    res = xiaoxiArr.value.find((val) => {
      return val.id == _streamId
    })
  }
  console.log('>>>>res>', res)
  closeStream(res)
}

function uploadBtnClick() {
  // upWjClickHandler()
}

async function upWjClickHandler(wjId: string) {
  console.log('>>upWjClickHandler>>>')
  if (isSending.value) {
    ElementTip.warningTip('请耐心等待小鸿把话说完')
    return
  }
  // if (await Utill.prePd()) {
  //   return
  // }
  // if (
  //   Data.uploadDocumentsData.documentsData &&
  //   Data.uploadDocumentsData.documentsData.length >= 4
  // ) {
  //   ElementTip.warningTip('最多上传4个哟')
  //   return
  // }

}

function refreshAllMessage() {
  closeStream(null);
  xiaoxiArr.value = []
  hosXiaoxiArr.value = []
  timestamp.value = ''
  newTimestamp.value = ''
  init();
  $emit('haveInformation', true);
  fixedTimestamp.value = String(Date.now())
  console.log('>>fixedTimestamp.value333>>>>', fixedTimestamp.value)
}

function handleVisibilityChange() {
  if (document.visibilityState == 'visible') {
    if (isalltext) {
      strforcode = alltext
      str_ = alltext
      //    backText.isCopy = true
    } else {
      str_ = alltext
      strforcode = str_ + '_'
    }
    console.log(Data.uploadStateWjId.value, '<<<<<<啦啦啦啦看到了', alltext)
    // if (Data.uploadStateWjId.value != '') {
    //   getUploadData(Data.uploadStateWjId.value)
    //   Data.uploadStateWjId.value = ''
    // }
  } else {
    // console.log(strforcode,'<<<<啦啦ss啦啦消失了')
  }
}

function handleScroll() {
  console.log('>scFra!.scrollTop>>>', scFra!.scrollTop)
  //如果已经加载到历史数据了
  //   if(isHosDataLoading){
  //   return
  // }
  if (isGetHosData) {
    return
  }
  if (!scFra) {
    return
  }
  if (scFra!.scrollTop != 0) {
    return
  }
  if (!props.isHaveTitle) {
    //问答
    return
  } else {
    gethoslist()
  }

}
function handleWheel(e) {
  //  < 0
  // console.log(isGetHosData,">>>>>>cscscs>>>>>>", e.deltaY )

  if (isGetHosData) {
    return
  }
  if (!scFra) {
    return
  }
  if (scFra!.scrollTop != 0) {
    return
  }
  if (e.deltaY > 0) {
    return
  }
  if (!props.isHaveTitle) {
    //问答
    return
  } else {
    gethoslist()
  }

  // gethoslist();
}
//h获取历史记录数据
function gethoslist() {
  isGetHosData = true
  // console.log(">>>>>Data.sessionId.value>>>" ,Data.sessionId.value)
  HTTP.getHistoryData(Data.sessionId.value, fixedTimestamp.value)
    .then(
      (data) => {
        let hosList = []
        if (data.data) {
          hosList = data.data
        }
        console.log(hosList.length > 0, '>>Data.sessionId.value>>>', data.data)
        if (hosList.length > 0) {
          hosXiaoxiArr.value = hosList
          console.log('历史记录data》》》》', hosXiaoxiArr.value)
          nextTick(() => {
            refreshTip('加载完成')
            let scrollTop = scFra!.scrollHeight - lastScrollHeight
            scFra!.scrollTop = scrollTop
            mathJaxShow('hos-ctr-math')
          })
          // _refreshText!.innerText = '加载中...';
        }
        // } else {
        //   refreshErr()
        // }
      },
      (err) => {
        refreshErr()
      }
    )
    .catch((e) => {
      refreshErr()
    })
}

function refreshTip(text: string) {
  // ElementTip.successTip(text)
  // _refreshText!.innerText = text
  // _refreshText!.style.transition = 'opacity 0.3s ease-out'
  // _refreshText!.style.opacity = 0 + ''
}

function refreshErr() {
  isGetHosData = false
  ElementTip.errorTip('加载失败，稍后重试哦')
}

//解析输出文字
function jxText(text: string) {
  const prefix = '**引用来自文档**'
  console.log('>>>>>dddddtext>>>>', text)
  const trimmedStr = text.replace(/^\s+/, '')
  // console.log("trimmedStr>>>>", trimmedStr)
  if (trimmedStr.startsWith(prefix)) {
    console.log('>引用来自文档**>>>>cscscs')
    return { text: trimmedStr.substring(prefix.length), isShow: true }
  }
  return { text: text, isShow: false }
}


function closeXhDialogue() {
  $emit('closeXhDialogue')
}

function closeFaqCard() {
  aQSelectedText.value = ''
  // console.log(xiaoxiArr.value)
  // xiaoxiArr.value.splice(index, 1)
  // console.log(xiaoxiArr.value)
}
</script>

<template>
  <div class="item-ctr">
    <div class="item-title" v-if="isHaveTitle">
      <div class="item-name">小鸿助教</div>
      <el-icon @click="closeXhDialogue">
        <Close />
      </el-icon>
    </div>
    <div class="dialog-container">
      <div class="pullToRefresh" id="massage-ctr" @scroll="handleScroll" @wheel="handleWheel">
        <!-- <div id="refreshText">下拉加载更多消息</div> -->

        <!-- 历史信息 -->
        <!-- {{hosXiaoxiArr}} -->
        <div id="hos-ctr-math">
          <div v-for="(hos, index) in hosXiaoxiArr" :key="hos.id" class="hosTab" :id="hos.id">
            <div v-if="hos.role == 'user'">
              <sendItemWd :backText="hos.content" v-if="hos.type == 'file'" @upLoadClick="upLoadClick"></sendItemWd>
              <SendItem :backText="hos.content as string" v-else></SendItem>
            </div>
            <div v-if="hos.role == 'assistant'">
              <VideoMessageItem :backText="''" v-if="hos.type == 'tuWenAndVideo'" :messageKey="hos.id"
                :otherData="JSON.parse(hos.content).tuWenAndVideo">
              </VideoMessageItem>
              <MessageItem v-else :isFeedback="false" :isHtml="!!resourceType" :isCopy="true"
                :backText="jxText(hos.content as string).text as string" :otherData="jxText(hos.content as string).isShow ? { answerText: '以下结合文档内容回答' } : {}
      " :messageKey="hos.id"></MessageItem>
            </div>
            <!-- 小程序历史信息 -->
            <div v-if="hos.position == 'right'">
              <SendItem :backText="(hos.content.text as string)" v-if="hos.type == 'text'"></SendItem>
              <sendItemWd :backText="hos.content.text" v-if="hos.type == 'file'" @upLoadClick="upLoadClick">
              </sendItemWd>
            </div>

            <div v-if="hos.position == 'left'">
              <MessageItem :isFeedback="false" :isHtml="false" :isCopy="true"
                :backText="(jxText(hos.content.text as string).text as string)"
                :otherData="jxText(hos.content.text as string).isShow ? { answerText: '以下结合文档内容回答' } : {}"
                v-if="hos.type == 'text'" :messageKey="hos._id"></MessageItem>
              <ZwHistory :isFeedback="false" :isHtml="false" :isCopy="true" :backText="JSON.parse(hos.content.text)"
                v-else-if="hos.type == 'zuowen' &&
      hos.content.text &&
      hos.content.text.length > 0
      " :messageKey="hos._id"></ZwHistory>
            </div>
          </div>
          <!-- <div class="hos-line-ctr" v-if="hosXiaoxiArr && hosXiaoxiArr.length > 0">
            <div class="hos-fg-tip">以上是历史记录</div>
          </div> -->
        </div>

        <!-- 新信息 -->
        <div id="new-ctr-math">
          <div v-for="(file, index) in xiaoxiArr" :key="file.id" class="tab" :id="file.id">
            <ModeContentItem v-if="file.type == 1" :backContent="file.text"> </ModeContentItem>
            <SendItem :backText="file.text as string" v-else-if="file.type == 2"> </SendItem>
            <SendItemWd :backText="file.text as any" v-else-if="file.type == 9" @upLoadClick="upLoadClick">
            </SendItemWd>
            <Card :isImg="file.isImg as boolean" :backText="file.text as Array<cardType>"
              :selectText="file.selectText as string" :isFAQ="file.isFAQ as boolean"
              v-else-if="file.type == 3 && !(file.isFAQ as boolean)" @clickCard="clickCard"></Card>
            <!-- <div style="display: none" v-else-if="file.type == 3 && (file.isFAQ as boolean)"></div> -->
            <VideoMessageItem :backText="file.text as Array<any>" v-else-if="file.type == 11"
              :problem="getAnswerProblem(index)" :isFeedback="file.isFeedback as boolean"
              :isHtml="file.isHtml as boolean" :isCopy="file.isCopy" @showFeedback="showFeedback"
              @VideoanginAnswer="videoanginAnswer" @addActionCard="addActionCard" @clickExampleCard="clickExampleCard"
              :messageKey="file.id" :isLast="index == xiaoxiArr.length - 1" :isShowJiaoanBtn="file.isShowJiaoanBtn"
              :loadingType="file.loadingType" :otherData="file.otherData">
            </VideoMessageItem>

            <MessageItem :problem="getAnswerProblem(index)" :isFeedback="file.isFeedback as boolean"
              :isHtml="file.isHtml as boolean" :isCopy="file.isCopy" :backText="file.text as Array<String>"
              @showFeedback="showFeedback" @anginAnswer="anginAnswer" @addActionCard="addActionCard"
              @clickExampleCard="clickExampleCard" :messageKey="file.id" :isLast="index == xiaoxiArr.length - 1"
              :isShowJiaoanBtn="file.isShowJiaoanBtn" :loadingType="file.loadingType" :otherData="file.otherData"
              v-else></MessageItem>
          </div>
        </div>

        <!-- loading -->
        <div v-show="lodingShow">
          <LoadingItem class="loding" :is-show="lodingShow"></LoadingItem>
        </div>
      </div>
      <!-- <div v-show="xiaoxiArr[xiaoxiArr.length - 1]?.isFAQ">
        <div class="faq-card" v-for="(file, index) in xiaoxiArr" :key="file.id" :id="file.id">
          <SelectTextCard :isImg="file.isImg as boolean" :backText="file.text as Array<cardType>"
            :selectText="file.selectText as string" :isFAQ="file.isFAQ as boolean"
            v-if="index == xiaoxiArr.length - 1 && (file.isFAQ as boolean)" @clickCard="clickCard"
            @closeFaqCard="closeFaqCard(index)"></SelectTextCard>
        </div>
      </div> -->
      <div class="faq-card" v-if="aQSelectedText">
        <SelectTextCard :isImg="false" :backText="FAQList as Array<cardType>" :selectText="aQSelectedText" :isFAQ="true"
          @clickCard="clickCard" @closeFaqCard="closeFaqCard">
        </SelectTextCard>
      </div>
    </div>

    <div class="editor-ctr">
      <DownControl @upWjClickHandler="getUploadData" v-if='!resourceType && !isApplicationLink'></DownControl>
      <EnterView :isSending="isSending" :isStartSteam="isStartSteam" @stopMassage="stopMassage"
        @sendQuestion="sendQuestion" @clickCard="clickCard" @uploadBtnClick="uploadBtnClick"
        @upWjClickHandler="upWjClickHandler" @refreshAllMessage="refreshAllMessage"
        :isApplicationLink="isApplicationLink" :aQSelectedText='aQSelectedText'>
      </EnterView>
      <div class="documents-item-ctr">
        <div v-for="(file, index) in Data.uploadDocumentsData.documentsData">
          <DocumentsItem :isNeedClose="true" :backText="file.value" @qxHandler="qxHandler" @upLoadClick="upLoadClick">
          </DocumentsItem>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hos-line-ctr {
  display: flex;
  align-items: center;
}

.hos-fg-tip::before,
.hos-fg-tip::after {
  background-image: linear-gradient(90deg, hsla(0, 0%, 93%, 0), rgba(180, 195, 221, 0.6));
  content: '';
  display: inline-block;
  height: 1px;
  position: relative;
  top: -4px;
  width: 90px;
}

.hos-fg-tip::before {
  margin-right: 8px;
}

.hos-fg-tip::after {
  margin-left: 8px;
  transform: scaleX(-1);
}

.hos-fg-tip {
  color: #959fa9;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 12px;
  margin: 16px 0;
  position: relative;
  text-align: center;
  width: 100%;
}

.item-ctr {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin: 0px 24px 12px 20px;
  margin-bottom: 12px;

  :deep(.el-icon) {
    font-size: 17px;
  }
}

.item-name {
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  letter-spacing: 1px;
  background: linear-gradient(90deg, #5648ec 0%, #2366ed 107%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

// .no-copy {
//   user-select: none;
//   /* 禁止选中文本 */
//   -webkit-user-select: none;
//   /* 兼容 Safari */
//   -ms-user-select: none;
//   /* 兼容 IE */
//   -moz-user-select: none;
//   /* 兼容 Firefox */
// }

.dialog-container {
  width: 100%;
  display: flex;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 0;
  position: relative;
  // padding: 0 0 0 10px;

}

.pullToRefresh {
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  overflow-y: scroll;
  position: static;
  z-index: 1;
  min-height: 0;
}

.documents-item-ctr {
  display: flex;
  // flex-wrap: nowrap;
  align-items: center;
  // padding: 8px;
  padding-top: 5px;
  gap: 8px;
  flex-wrap: wrap;
  // overflow-x: scroll;
}

.pullToRefresh>* {
  transform: translateZ(0px);
  -webkit-transform: translateZ(0px);
}

#refreshText {
  text-align: center;
  font-size: 12px;
  opacity: 1;
  color: #666666;
  font-weight: normal;
  line-height: 24px;
}

.dialog-mess {
  padding: 0 0 16px 0;
  max-width: 95%;
  -webkit-animation: msgLeft 0.5s ease-in-out;
  animation: msgLeft 0.5s ease-in-out;
  height: calc(100% - 78px);
}

.dialog-mess-ctr {
  display: flex;
  //justify-content: flex-end;
  width: 100%;
  padding-left: 17px;
  overflow: hidden;
  -webkit-animation: msgRight 0.5s ease-in-out;
  animation: msgRight 0.5s ease-in-out;
}

.rounded-circle {
  display: block;
}

.avatar {
  min-width: 35px;
  min-height: 35px;
  border-radius: 30px;
  overflow: hidden;

  height: 35px;
  width: 35px;
  flex-shrink: 0;
}



.cro {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  transform: rotate(270deg);
}

.cro_left_top {
  background: linear-gradient(180deg, #f3f3f6 0%, #eaedf6 100%);
  border-radius: 0 0 90% 0;
  /* border-bottom: 1px solid #f5f6fa; */
  /* border-right: 2px solid #f5f6fa; */
  width: 100%;
  height: 100%;
}

.default-tip {
  color: #bbbbbb;
  font-size: 14px;
  font-weight: 350;
  line-height: 24px;
  letter-spacing: 0px;
}

.editor-ctr {
  width: 100%;
  position: relative;
  // display: flex;
  margin-bottom: 10px;
}

.refresh-ctr {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #485cec;
}

.input-ctr {
  width: 278px;
  min-height: 40px;
  //border-radius: 269px;
  opacity: 1;
  //background: #FFFFFF;
  margin-left: 8px;
  margin-right: 10px;
}

.send-ctr {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #485cec;
  display: flex;
  align-items: center;
  justify-content: center;
}

.send-img {
  width: 20px;
  height: 20px;
}

.faq-card {
  width: 100%;
  position: relative;
  display: flex;
  margin-bottom: 14px;
}
</style>
